import React from 'react'
import { Route } from 'react-router-dom'
import PerdasDevedoresDuvidososPage from './pdd/PerdasDevedoresDuvidososPage'
import ApuracaoIcms from './apuracao-icms/ApuracaoIcms'
import SwitchRouter from 'components/SwitchRouter'

export default function Routes({ match: { path } }) {
    const routes = [
        { path: `${path}/apuracao-icms`, component: ApuracaoIcms, restricted: 'dre>conferirApuracaoICMS' },
        { path: `${path}/perdas-devedores-duvidosos`, component: PerdasDevedoresDuvidososPage, restricted: 'dre>listPdd' }
    ]
    return (
        <SwitchRouter>
            {routes.map((props, i) => <Route key={i} {...props} />)}
        </SwitchRouter>
    )
}
